export const INITIAL_LOADING_TEXT = 'Loading course data...'
export const DEFAULT_UNIT = 'unit-1'
export const MILISECONDS_BEFORE_REFRESH = 5000
export const TAB_TITLE = 'Lessons'
